module.exports = __webpack_public_path__ + "static/media/Jagt_billede_app.f3e00bbd.jpg";